import { useMemo } from 'react';
import { transformFormValuesToValuation } from '../../utils/transformation';
import type { NarrativeForm } from '../../utils/schema';

export interface NarrativeInputPayload {
  id?: string;
  title: string;
  companyId: string;
  userHoldsPosition: boolean;
  contentBlocks: Array<{
    contentHtml: string;
    title: string;
  }>;
  valuations: Array<ReturnType<typeof transformFormValuesToValuation>>;
}

export const useNarrativeInputPayload = ({
  values,
  narrativeId,
  companyId,
}: {
  values: NarrativeForm;
  narrativeId?: string;
  companyId: string;
}) => {
  const narrativeInputPayload = useMemo((): NarrativeInputPayload => {
    const { title, content, userHoldsPosition } = values;

    return {
      ...(narrativeId ? { id: narrativeId } : {}),
      title,
      companyId: companyId,
      userHoldsPosition: userHoldsPosition ?? false,
      contentBlocks: content.html
        ? [
            {
              contentHtml: content.html,
              title,
            },
          ]
        : [],
      valuations: [
        transformFormValuesToValuation({
          values,
        }),
      ],
    };
  }, [values, narrativeId, companyId]);

  return narrativeInputPayload;
};
